import styled, { css } from 'styled-components';
import { OptimusPlainLink } from '@mews-commander/ui';
import { getToken, Icon, IconName } from '@optimus-web/core';
import { COLOR_DANGER, COLOR_WHITE } from '../../../components/commander-ui/constants';

export const ReservationList = styled.ul`
    padding-left: 0px;
    list-style: none;
`;

export const ReservationListItem = styled.li`
    min-height: 40px;
`;

export const ReservationListItemWrapper = styled.div`
    border-radius: ${getToken('borderRadius50')}px;
    background: ${COLOR_WHITE};
    transition: box-shadow 450ms ease-in-out;
    box-shadow: ${getToken('shadow100')};
    border: 1px solid transparent;

    ${(props) => (props as $TSFixMe).unconfirmed && `border-style: dashed;`}

    ${(props) =>
        (props as $TSFixMe).selected &&
        css`
            border-color: ${(props as $TSFixMe).borderColor};
            box-shadow: ${getToken('shadow200')};
        `}
`;

export const NoRoomIcon = styled(Icon)`
    color: ${COLOR_DANGER};
`;
NoRoomIcon.defaultProps = {
    value: IconName.Problematic,
};

export const ResourceDetailElement = styled.span`
    display: flex;

    flex: 2;

    word-break: break-all;
`;

export const ReservationDetailElement = styled.span`
    display: flex;
    flex-direction: column;

    flex: 6;
`;

export const ActionElement = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;

    flex: 0;
`;

export const ReservationDetailContent = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;

    flex: 1 1;
`;

export const OccupancyElement = styled.span`
    flex: 0;
`;

export const ResourceElement = styled(OptimusPlainLink)`
    ${(props) => props.color && `color: ${props.color};`}
`;
